<template>
    <transition name="fade">
        <div v-if="!noteCompData.showAdd">
            <div class="row">
                <div class="col-sm--4">
                    <page-size v-model="noteCompData.pageSize" @input="search" />
                </div>
                <div class="col-sm">
                    <order-by v-model="noteCompData.selectedOrderBy"
                              :options="noteCompData.orderByOptions"
                              @goClick="search" />
                </div>
            </div>
            <hr />
            <div class="row">
                <div class="col">
                    <span><i class="fas fa-info-circle mr-2"></i>Click a note to display below.</span>
                </div>
                <div class="col mb-2">
                    <div class=" float-right">
                        <button class="btn btn-primary btn-sm" @click="() => { noteCompData.selectedNote = {}; noteCompData.showAdd = true; }">Add Note</button>
                    </div>
                </div>
            </div>
            
            <data-list :dataCols="claimNotesCols"
                       :dataListItems="selectedClaim.notes"
                       :tableClass="'table table-striped table-sm'"
                       @sgl-click="(payload) => noteCompData.selectedNote = payload[0]" />
            <b-pagination align="center"
                          size="md"
                          :total-rows="totalRecords"
                          v-model="noteCompData.pageNumber"
                          :per-page="noteCompData.pageSize"
                          :size="'sm'"
                          @input="handlePagenationInput" />
           
            <div v-if="showNote">
                <hr />
                <textarea class="form-control form-control-sm"
                          id="selectedNoteBody"
                          rows="3"
                          disabled
                          placeholder="Note"
                          v-model="noteCompData.selectedNote.body"></textarea>
                
            </div>
        </div>
        <div v-else>
            <div class="form-group">
                <label for="exampleFormControlInput1">Title</label>
                <input type="text" class="form-control form-control-sm" id="exampleFormControlInput1" v-model="noteCompData.newNote.title" placeholder="Title">
            </div>
            <div class="form-group mb-3">
                <label for="exampleFormControlTextarea1">Note</label>
                <textarea class="form-control form-control-sm" id="exampleFormControlTextarea1" rows="3" v-model="noteCompData.newNote.body" placeholder="Note"></textarea>
            </div>
            <button class="btn btn-secondary btn-sm mr-2" @click="() => noteCompData.showAdd = false">Cancel</button>
            <button class="btn btn-primary btn-sm"
                    :disabled="noteCompData.newNote.body == null || noteCompData.newNote.title == null"
                    @click="() => {
                        addClaimNote2({ claimId: selectedClaim.claimId, ...noteCompData.newNote })
                        noteCompData.newNote = {}
                        noteCompData.showAdd = false
                        noteCompData.pageSize = 10
                        }">
                Add
            </button>
        </div>
    </transition>
</template>

<script>

    import PageSize from '@/components/PageSize.vue'
    import OrderBy from '@/components/OrderBy.vue'
    import DataList from '@/components/DataList.vue'

    import { mapActions } from 'vuex'

    import { claimNotesCols } from '@/ui.config/cols/claimNotesCols'

    export default {
        name: 'ClaimNote',
        components: {
            DataList,
            PageSize,
            OrderBy
        },
        props: {

        },
        computed: {
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            totalRecords() {
                if (this.selectedClaim.notes[0]) {
                    return this.selectedClaim.notes[0].totalRecords
                }
            },
            showNote() {
                return this.noteCompData.selectedNote.title != null
            }
        },
        data: () => {
            return {
                claimNotesCols: claimNotesCols,
                noteCompData: {
                    pageNumber: 1,
                    pageSize: 10,
                    selectedOrderBy: null,
                    orderByOptions: [
                        {
                            id: 0,
                            key: 'UserEmail',
                            label: 'User'
                        },
                        {
                            id: 1,
                            key: 'DateCreated',
                            label: 'Date'
                        }
                    ],
                    selectedNote: {},
                    showAdd: false,
                    newNote: {
                        title: null,
                        body: null
                    }
                }
            }
        },
        beforeMount() {
            if (this.selectedClaim.notes && this.selectedClaim.notes.length > 0) {

            } else {
                this.noteCompData.showAdd = true
            }
        },
        methods: {
            ...mapActions([
                'fetchNotesForClaim',
                'addClaimNote2'
            ]),
            search() {
                let { claimId } = this.selectedClaim
                let { pageSize, pageNumber, selectedOrderBy } = this.noteCompData

                let ordering = null

                if (selectedOrderBy) {
                    let { orderBy } = selectedOrderBy

                    ordering = {
                        orderBy: orderBy ? orderBy.key : null,
                        sortDirection: selectedOrderBy.direction
                    }
                }

                let pages = {
                    pageSize,
                    pageNumber
                }

                let criteria = {
                    claimId,
                    ...pages,
                    ...ordering
                }

                this.fetchNotesForClaim(criteria)
            },
            handlePagenationInput(payload) {
                this.noteCompData.pageNumber = payload
                this.search(0)
            },
        }
    }
</script>